/* eslint-disable no-unused-vars */
// third-party
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//icons
import
{
   faTag,
   faCircleEuro,
   faMoneyBillTrendUp,
   faChartMixed,
   faUserGraduate,
   faMemo,
   faFolderOpen,
   faListCheck
} from '@fortawesome/pro-regular-svg-icons';

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const report = {
   id: 'report',
   title: 'Report',
   type: 'group',
   permissions: ['superadmin', 'admin', 'erp_admin', 'erp_scadenze-documenti', 'erp_scadenze-corsi', 'erp_risorse-assegnate', 'erp_ricavi-attivita', 'erp_ricavi-attivita_ricavi', 'erp_compensi', 'erp_compensi_compensi'],
   children: [
      {
         id: 'report-risorse-assegnate',
         title: 'Risorse assegnate',
         pageTitle: 'Risorse assegnate',
         type: 'item',
         permissions: ['superadmin', 'admin', 'erp_admin', 'erp_risorse-assegnate'],
         url: '/report/risorse-assegnate',
         icon: () => <FontAwesomeIcon icon={faTag} size="lg" />,
      },
      {
         id: 'report-compensi',
         title: 'Compensi',
         pageTitle: 'Compensi',
         type: 'item',
         permissions: ['superadmin', 'admin', 'erp_admin', 'erp_compensi_compensi', 'erp_compensi'],
         url: '/report/compensi',
         icon: () => <FontAwesomeIcon icon={faCircleEuro} size="lg" />,
      },
      {
         id: 'ricavi-attivita',
         title: 'Ricavi Attività',
         pageTitle: 'Ricavi Attività',
         type: 'item',
         permissions: ['superadmin', 'admin', 'erp_admin', 'erp_ricavi-attivita_ricavi', 'erp_ricavi-attivita'],
         url: '/report/ricavi-attivita',
         icon: () => <FontAwesomeIcon icon={faMoneyBillTrendUp} size="lg" />,
      },
      {
         id: 'analisi-ricavi',
         title: 'Marginalità',
         pageTitle: 'Marginalità',
         type: 'item',
         permissions: ['superadmin', 'admin', 'erp_admin', 'erp_marginalita'],
         url: '/report/analisi-ricavi',
         icon: () => <FontAwesomeIcon icon={faChartMixed} size="lg" />,
      },
      {
         id: 'scadenze-corsi',
         title: 'Scadenze Corsi',
         pageTitle: 'Scadenze Corsi',
         type: 'item',
         permissions: ['superadmin', 'admin', 'erp_admin', 'erp_scadenze-corsi'],
         url: '/report/scadenze-corsi',
         icon: () => <FontAwesomeIcon icon={faUserGraduate} size="lg" />,
      },
      {
         id: 'scadenze-documenti',
         title: 'Scadenze Documenti',
         pageTitle: 'Scadenze Documenti',
         type: 'item',
         permissions: ['superadmin', 'admin', 'erp_admin', 'erp_scadenze-documenti'],
         url: '/report/scadenze-documenti',
         icon: () => <FontAwesomeIcon icon={faMemo} size="lg" />,
      },
      {
         id: 'pratiche',
         title: 'Pratiche',
         pageTitle: 'Pratiche',
         type: 'item',
         permissions: ['superadmin', 'admin', 'erp_admin', 'erp_pratiche'],
         url: '/report/pratiche',
         icon: () => <FontAwesomeIcon icon={faFolderOpen} size="lg" />,
      },
      {
         id: 'sopralluoghi',
         title: 'Sopralluoghi',
         pageTitle: 'Sopralluoghi',
         type: 'item',
         permissions: ['superadmin', 'admin', 'erp_admin', 'erp_sopralluoghi'],
         url: '/report/sopralluoghi',
         icon: () => <FontAwesomeIcon icon={faListCheck} size="lg" />,
      }
   ]
};

export default report;
